module.exports = __webpack_public_path__ + "static/mockup-find-leagues-babd102f660d0f8fa2c09f142b632010.png";